import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import DoctorApp from './DoctorApp'
import NurseApp from './NurseApp'
import * as serviceWorker from './serviceWorker';
import 'typeface-roboto'
import { ThemeProvider, createMuiTheme } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

const euromedisTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#0871b9',
      light: '#00a1e0',
      dark: '#004f87'
    },
    secondary: {
      main: '#f7d22c'
    }
  },
  typography: {
    fontFamily: 'Arial',
  }
})

const SubApp: React.FC = function () {
  return (
    <NurseApp returnUrl={'https://euromedis.pl/jak-zlozyc-e-deklaracje-do-poz/'} />
  )
}

const RootApp: React.FC = function () {
  return (
    <ThemeProvider theme={euromedisTheme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <SubApp />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}

ReactDOM.render(<RootApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
